export default "__VITE_ASSET__C3oulHjU__"